import React from 'react';
import { Modal } from './Modal';

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function TermsModal({ isOpen, onClose }: TermsModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Regulamin serwisu liczymy.nauczniaczek.pl"
    >
      <div className="prose max-w-none space-y-6">
        <section>
          <h3 className="text-xl font-bold">§1. Postanowienia ogólne</h3>
          <div className="space-y-2">
            <p>
              Właścicielem i administratorem serwisu internetowego liczymy.nauczniaczek.pl (dalej: "Serwis") jest JG Invest PSA z siedzibą w Oświęcimiu przy ulicy Jana Matejki, wpisana do rejestru przedsiębiorców pod numerem KRS 0000915798, NIP 5492463888, REGON 389702924.
            </p>
            <p>
              Serwis jest platformą edukacyjną przeznaczoną dla dzieci w wieku szkolnym, służącą nauce matematyki poprzez zabawę.
            </p>
            <p>
              Regulamin został sformułowany w sposób przystępny i zrozumiały dla dzieci oraz ich opiekunów prawnych.
            </p>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">§2. Definicje</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>Serwis - platforma edukacyjna dostępna pod adresem liczymy.nauczniaczek.pl</li>
            <li>Administrator - JG Invest PSA</li>
            <li>Użytkownik - dziecko korzystające z Serwisu</li>
            <li>Opiekun - rodzic lub opiekun prawny Użytkownika</li>
            <li>Konto - indywidualne konto Użytkownika w Serwisie</li>
            <li>Treści - materiały edukacyjne, zadania, gry i inne elementy dostępne w Serwisie</li>
          </ul>
        </section>

        <section>
          <h3 className="text-xl font-bold">§3. Rejestracja i zgoda opiekuna</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Korzystanie z Serwisu przez osoby poniżej 13 roku życia wymaga:</p>
              <ul className="list-disc pl-5">
                <li>Rejestracji dokonanej przez Opiekuna</li>
                <li>Wyrażenia zgody przez Opiekuna na korzystanie z Serwisu</li>
                <li>Podania adresu email Opiekuna do kontaktu</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Proces rejestracji obejmuje:</p>
              <ul className="list-disc pl-5">
                <li>Utworzenie konta przez Opiekuna</li>
                <li>Potwierdzenie adresu email</li>
                <li>Ustalenie bezpiecznego hasła</li>
                <li>Określenie wieku Użytkownika</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Opiekun ma prawo do:</p>
              <ul className="list-disc pl-5">
                <li>Wglądu w aktywność dziecka w Serwisie</li>
                <li>Modyfikacji ustawień konta</li>
                <li>Usunięcia konta</li>
                <li>Ograniczenia czasu korzystania z Serwisu</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">§4. Bezpieczeństwo dzieci</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Administrator zapewnia:</p>
              <ul className="list-disc pl-5">
                <li>Brak reklam nieodpowiednich dla dzieci</li>
                <li>Brak przekierowań do zewnętrznych stron</li>
                <li>Moderację wszelkich treści generowanych przez użytkowników</li>
                <li>Ochronę przed nieodpowiednimi treściami</li>
                <li>Brak możliwości kontaktu między użytkownikami</li>
                <li>Brak zbierania nadmiarowych danych osobowych</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Ograniczenia czasowe:</p>
              <ul className="list-disc pl-5">
                <li>Możliwość ustawienia limitów czasowych przez Opiekuna</li>
                <li>Przypomnienia o przerwach w nauce</li>
                <li>Blokada dostępu po przekroczeniu ustalonego czasu</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">§5. Ochrona danych osobowych dzieci</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Administrator zbiera minimalny zakres danych niezbędnych do funkcjonowania Serwisu:</p>
              <ul className="list-disc pl-5">
                <li>Wiek dziecka</li>
                <li>Postępy w nauce</li>
                <li>Statystyki użytkowania</li>
                <li>Email Opiekuna</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Dane są przetwarzane zgodnie z:</p>
              <ul className="list-disc pl-5">
                <li>Rozporządzeniem RODO</li>
                <li>Ustawą o ochronie danych osobowych</li>
                <li>Szczególnymi wymogami dotyczącymi ochrony danych dzieci</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Opiekun ma prawo do:</p>
              <ul className="list-disc pl-5">
                <li>Wglądu w dane dziecka</li>
                <li>Modyfikacji danych</li>
                <li>Usunięcia danych</li>
                <li>Przeniesienia danych</li>
                <li>Ograniczenia przetwarzania</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">§6. Funkcjonalności edukacyjne</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Serwis oferuje:</p>
              <ul className="list-disc pl-5">
                <li>Zadania matematyczne dostosowane do wieku</li>
                <li>System motywacyjny (naklejki, punkty)</li>
                <li>Statystyki postępów</li>
                <li>Różne poziomy trudności</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Metodyka nauczania:</p>
              <ul className="list-disc pl-5">
                <li>Dostosowanie do podstawy programowej</li>
                <li>Stopniowanie trudności</li>
                <li>Natychmiastowa informacja zwrotna</li>
                <li>System powtórek</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">§7. Wsparcie i pomoc</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Serwis zapewnia:</p>
              <ul className="list-disc pl-5">
                <li>Pomoc techniczną dla Opiekunów</li>
                <li>Instrukcje dostosowane do wieku dziecka</li>
                <li>Wsparcie w rozwiązywaniu problemów</li>
                <li>Kontakt z obsługą przez email</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Kanały pomocy:</p>
              <ul className="list-disc pl-5">
                <li>Email: pomoc@nauczniaczek.pl</li>
                <li>Formularz kontaktowy</li>
                <li>Sekcja FAQ</li>
                <li>Instrukcje dla Opiekunów</li>
              </ul>
            </div>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">§8. Postanowienia końcowe</h3>
          <div className="space-y-4">
            <div>
              <p className="font-semibold">Regulamin jest dostępny w dwóch wersjach:</p>
              <ul className="list-disc pl-5">
                <li>Pełnej - dla Opiekunów</li>
                <li>Uproszczonej - dla dzieci</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Zmiany regulaminu:</p>
              <ul className="list-disc pl-5">
                <li>Będą komunikowane z wyprzedzeniem</li>
                <li>Wymagają akceptacji Opiekuna</li>
                <li>Będą przedstawiane w przystępnej formie</li>
              </ul>
            </div>

            <p>
              W przypadku pytań lub wątpliwości prosimy o kontakt: kontakt@nauczniaczek.pl
            </p>
          </div>
        </section>

        <section>
          <h3 className="text-xl font-bold">§9. Wersja dla dzieci</h3>
          <div className="bg-blue-50 p-4 rounded-lg space-y-4">
            <p className="text-lg">Cześć! 👋</p>
            <p>To jest Twój przewodnik po Nauczniaczku. Przeczytaj go z rodzicami!</p>

            <div>
              <p className="font-semibold">Czym jest Nauczniaczek?</p>
              <ul className="list-disc pl-5">
                <li>To miejsce, gdzie możesz uczyć się matematyki poprzez zabawę</li>
                <li>Zdobywasz punkty i naklejki za rozwiązane zadania</li>
                <li>Możesz śledzić swoje postępy</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Zasady bezpieczeństwa:</p>
              <ul className="list-disc pl-5">
                <li>Korzystaj z Nauczniaczka za zgodą rodziców</li>
                <li>Nie podawaj swoich prawdziwych danych</li>
                <li>Rób przerwy w nauce</li>
                <li>Jeśli coś Cię zaniepokoi, powiedz o tym rodzicom</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Jak zdobywać punkty?</p>
              <ul className="list-disc pl-5">
                <li>Rozwiązuj zadania</li>
                <li>Zbieraj naklejki</li>
                <li>Przechodź na wyższe poziomy</li>
                <li>Baw się i ucz!</li>
              </ul>
            </div>

            <div>
              <p className="font-semibold">Potrzebujesz pomocy?</p>
              <ul className="list-disc pl-5">
                <li>Poproś rodziców o pomoc</li>
                <li>Użyj przycisku "Pomoc"</li>
                <li>Przeczytaj instrukcję</li>
              </ul>
            </div>

            <p className="text-lg font-medium mt-4">Pamiętaj, że nauka może być świetną zabawą! 🌟</p>
          </div>
        </section>

        <p className="text-sm text-gray-500 mt-8">Data ostatniej aktualizacji: 06.02.2025</p>
      </div>
    </Modal>
  );
}